import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <section className="pt-24 pb-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <Breadcrumb />

            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-4">
                关于每日黑料
              </h1>
              <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
                全网最快、最全、最真实的娱乐爆料平台
              </p>
            </div>

            <div className="relative w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden mb-14">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20abstract%20artistic%20composition%20with%20warm%20beige%20and%20deep%20crimson%20accents%20flowing%20ink%20texture%20mysterious%20atmosphere%20editorial%20magazine%20style%20about%20us%20banner%20wide%20panoramic%20format%20sophisticated%20and%20elegant&width=1400&height=600&seq=about-hero-bg&orientation=landscape"
                alt="关于每日黑料"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="mb-16">
              <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
                品牌介绍
              </p>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
                我们的故事
              </h2>
              <div className="text-base md:text-lg text-foreground-700 leading-relaxed space-y-5">
                <p>
                  每日黑料成立于2024年，由一群对娱乐行业充满热情、对真相执着追求的内容创作者共同创立。我们深知在信息爆炸的时代，公众对真实、及时、有深度的娱乐资讯有着巨大的需求，但市面上充斥着大量标题党、假新闻和低质量内容——这就是每日黑料诞生的初衷。
                </p>
                <p>
                  我们的团队由资深娱乐记者、数据分析师、法律顾问和技术开发人员组成，覆盖了从信息采集、事实核查到内容呈现的全流程。每一条爆料在发布前都会经过至少三轮交叉验证，确保信息的准确性和可靠性。我们坚持"不实不报、不快不发"的原则，在速度和准确度之间找到最佳平衡。
                </p>
                <p>
                  经过两年的发展，每日黑料已成长为中文互联网最具影响力的娱乐资讯平台之一。我们累计发布爆料超过12,850条，其中超过3,200条经过多方验证属实，爆料准确率高达98.6%。平台月活跃用户已突破580万，日均页面浏览量超过2,000万次。
                </p>
              </div>
            </div>

            <div className="mb-16">
              <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
                平台声誉
              </p>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
                业界认可
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-shield-check-line text-lg"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                    98.6% 准确率
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    经第三方机构独立评估，每日黑料的爆料内容准确率位居行业第一，远超同类平台平均水平。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-award-line text-lg"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                    2025年度最佳
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    荣获"2025年中国互联网最佳娱乐资讯平台"称号，获得行业内外一致好评。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-user-heart-line text-lg"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                    580万+ 忠实用户
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    月活跃用户突破580万，用户日均停留时长超过15分钟，用户粘性行业领先。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-newspaper-line text-lg"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                    50+ 主流媒体引用
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    每日黑料的独家爆料已被超过50家主流媒体引用报道，在行业内具有广泛影响力。
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-16">
              <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
                数据表现
              </p>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-8">
                用数据说话
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
                <div className="text-center">
                  <div className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-1">
                    12,850<span className="text-primary-500">+</span>
                  </div>
                  <p className="text-sm text-foreground-500">累计爆料</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-1">
                    3,200<span className="text-primary-500">+</span>
                  </div>
                  <p className="text-sm text-foreground-500">已验证爆料</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-1">
                    98.6<span className="text-primary-500">%</span>
                  </div>
                  <p className="text-sm text-foreground-500">准确率</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-1">
                    580<span className="text-primary-500">万+</span>
                  </div>
                  <p className="text-sm text-foreground-500">月活用户</p>
                </div>
              </div>
            </div>

            <div>
              <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
                联系我们
              </p>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-8">
                与我们取得联系
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-4">商务合作</h3>
                  <div className="space-y-3 text-sm text-foreground-600">
                    <p className="flex items-center gap-2">
                      <i className="ri-mail-line text-primary-500"></i>
                      hello@66012.cn
                    </p>
                    <p className="flex items-center gap-2">
                      <i className="ri-phone-line text-primary-500"></i>
                      400-888-6666
                    </p>
                  </div>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-4">线索投稿</h3>
                  <div className="space-y-3 text-sm text-foreground-600">
                    <p className="flex items-center gap-2">
                      <i className="ri-mail-line text-primary-500"></i>
                      hello@66012.cn
                    </p>
                    <p className="flex items-center gap-2">
                      <i className="ri-wechat-line text-primary-500"></i>
                      微信公众号：每日黑料
                    </p>
                  </div>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-4">媒体垂询</h3>
                  <div className="space-y-3 text-sm text-foreground-600">
                    <p className="flex items-center gap-2">
                      <i className="ri-mail-line text-primary-500"></i>
                      hello@66012.cn
                    </p>
                    <p className="flex items-center gap-2">
                      <i className="ri-map-pin-line text-primary-500"></i>
                      北京市朝阳区建国路88号
                    </p>
                  </div>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-4">加入我们</h3>
                  <div className="space-y-3 text-sm text-foreground-600">
                    <p className="flex items-center gap-2">
                      <i className="ri-mail-line text-primary-500"></i>
                      hello@66012.cn
                    </p>
                    <p className="flex items-center gap-2">
                      <i className="ri-briefcase-line text-primary-500"></i>
                      查看开放职位
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于每日黑料",
            "description": "每日黑料——全网最快、最全、最真实的娱乐爆料平台。覆盖网红塌房、明星黑料、吃瓜大赛等热门内容，吃瓜群众必备入口。",
            "url": "http://66012.cn/about",
            "publisher": { "@type": "Organization", "name": "每日黑料" },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://66012.cn/" },
              { "@type": "ListItem", "position": 2, "name": "关于我们" },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "每日黑料的爆料内容是否真实可靠？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "每日黑料所有爆料内容在发布前都经过至少三轮交叉验证，确保信息的准确性和可靠性。平台累计发布爆料超过12,850条，其中超过3,200条经过多方验证属实，准确率高达98.6%。"
                }
              },
              {
                "@type": "Question",
                "name": "如何向每日黑料投稿爆料线索？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "您可以通过发送邮件至 hello@66012.cn 或关注微信公众号'每日黑料'进行线索投稿。我们会对每一条投稿严格保密，并在核实后第一时间发布。"
                }
              },
              {
                "@type": "Question",
                "name": "每日黑料的内容更新频率是怎样的？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "每日黑料实行全天候内容更新机制，编辑团队7x24小时轮值，确保第一时间为您带来最新最热的娱乐爆料资讯。"
                }
              },
              {
                "@type": "Question",
                "name": "每日黑料有哪些内容分类？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "每日黑料涵盖网红塌房、明星黑料、吃瓜大赛、八卦深度、直播翻车、综艺瓜中瓜等六大核心分类，全方位覆盖娱乐八卦领域。"
                }
              },
            ],
          }),
        }}
      />
    </>
  );
}